import { msalConfig } from 'configs/msalConfig';

import { env } from 'configs/EnvironmentConfig';

import msal from './msalBrowser';



const PublicClientApplication =

	msal.PublicClientApplication ?? msal.default?.PublicClientApplication;



let initPromise = null;



/**

 * Create and bootstrap the single shared MSAL instance.

 * Per MSAL guidance, initialize() must run before any other API, and

 * handleRedirectPromise() completes any in-flight redirect and clears a stray

 * auth fragment from the main window (a no-op for the popup flow).

 */

const initializeMsal = () => {

	if (!initPromise) {

		if (!PublicClientApplication) {

			return Promise.reject(

				new Error('MSAL PublicClientApplication is unavailable')

			);

		}



		try {

			const instance = new PublicClientApplication(msalConfig);

			initPromise = instance

				.initialize()

				.then(() => instance.handleRedirectPromise())

				.then(() => instance)

				.catch((error) => {

					// Reset so a later attempt can retry a clean bootstrap.

					initPromise = null;

					throw error;

				});

		} catch (error) {

			initPromise = null;

			return Promise.reject(error);

		}

	}



	return initPromise;

};



const isMicrosoftOAuthEnabled = () =>
	Boolean(env.MICROSOFT_OAUTH_ENABLED) && Boolean(env.MICROSOFT_CLIENT_ID);

export const acquireMsalInstance = () => {

	if (!isMicrosoftOAuthEnabled()) {

		return Promise.resolve(null);

	}



	return initializeMsal();

};



/** Bootstrap MSAL at app startup (no-op when Microsoft auth is not configured). */

export const bootstrapMsal = () => {

	if (!isMicrosoftOAuthEnabled()) {

		return Promise.resolve(null);

	}



	return initializeMsal().catch(() => null);

};

